<template>
    <div class="app" :style="{'background': background}">
		<empty v-if="networkError" type="network"></empty>
		<slot v-else></slot>
		
		<div v-if="$slots.foot" v-show="footer" class="foot-place">
			<div class="foot flex-center-cross" :style="{'bottom': tabbar ? '1.12rem' : 0}">
				<slot name="foot"></slot>
			</div>
		</div>
		
		<div v-if="$slots.button" class="button-place">
			<div class="button flex-center" :style="{'bottom': tabbar ? '1.12rem' : 0}">
				<slot name="button"></slot>
			</div>
		</div>
		
		<div v-if="createButton" class="create flex-center" @click="$emit('create')"><i class="tf tf-plus"></i></div>
		
		<div v-if="tabbar" class="tabbar-box">
			<div class="tabbar flex">
				<div v-for="(item, i) in tabbarList" :key="i" class="flex-column flex-center flex-grow item" :class="{'z-crt': $route.path == item.path}" @click="navigateTo(item.path, current ? 'replace' : 'clear')">
					<i class="tf" :class="[item.icon, {'z-crt': $route.path == item.path}]"></i>
					<p>{{item.name}}</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import empty from '@/components/public/empty.vue'
	import {mapState} from 'vuex'
	
	export default {
		components: {
			empty
		},
		
		props: {
			tabbar: {
				type: Boolean,
				default: true
			},
			createButton: Boolean,
			background: String
		},
		
		data() {
			return {
				tabbarList: [{
					icon: 'tf-tab-home',
					name: '首页',
					path: '/'
				}, {
					icon: 'tf-tab-mine',
					name: '我的',
					path: '/mine'
				}],
				footer: true
			}
		},
		
		computed: {
			...mapState(['networkError']),
			
			current() {
				return ['/', '/mine'].includes(this.$route.path);
			}
		}
	};
</script>

<style lang="stylus" scoped>
	.app {
		min-height: 100vh;
		overflow: hidden;
		
		.foot {
			z-index: 99;
			position: fixed;
			left: 0;
			right: 0;
			bottom: 0;
			height: 1.04rem;
			border-top: 1px solid #D8DCE5;
			padding: 0 .4rem;
			background: #fff;
			
			&-place {
				height: 1.04rem;
			}
		}
		
		.button {
			z-index: 99;
			position: fixed;
			left: 0;
			right: 0;
			bottom: 0;
			height: 1.28rem;
			border-top: 1px solid #D8DCE5;
			padding: 0 .4rem;
			background: #fff;
			
			&-place {
				height: 1.28rem;
			}
			
			& > div {
				display: flex;
				width: 100%;
			}
			
			>>> .c-button {
				flex-grow: 1;
			}
		}
		
		.create {
			position: fixed;
			right: .22rem;
			bottom: 1.62rem;
			width: 1rem;
			height: 1rem;
			border-radius: 100%;
			font-size: .36rem;
			color: #fff;
			background: #3296FA;
			box-shadow: 0 0 20px 0 rgba(0,92,184,.4);
		}
	
		.tabbar {
			z-index: 99;
			position: fixed;
			left: 0;
			right: 0;
			bottom: 0;
			height: 1.12rem;
			background: #fff;
			box-shadow: 0 0 8px 0 rgba(0,0,0,.1);
			
			elder({
				height: 1.5rem
			})
			
			&-box {
				height: 1.12rem;
				
				elder({
					height: 1.5rem
				})
			}
			
			.item {
				&.z-crt {
					.tf, p {
						color: #0366F1;
					}
				}
				
				.tf {
					font-size: .4rem;
					color: #363A44;
					
					elder({
						font-size: .52rem
					})
				}
				
				p {
					margin-top: .1rem;
					font-size: .28rem;
					color: #686B73;
					
					elder({
						margin-top: .14rem,
						font-size: .4rem
					})
				}
			}
		}
	}
</style>
